import React from 'react';
import closeIcon from '../close.svg';
import styles from '../BottomDrawer.module.scss';

interface BottomDrawerHeaderProps {
    children?: React.ReactNode;
    width?: string;
    onClose?: () => void;
}
function BottomDrawerHeader({ children, width, onClose }: BottomDrawerHeaderProps) {
    return (
        <div className={styles.DrawerHeader}>
            <div className={styles.DrawerHeaderText} style={width ? { width } : {}}>
                {children}
            </div>
            {onClose && (
                <img className={styles.DrawerHeaderClose} src={closeIcon} alt="close" style={{ height: '0.9375rem' }} onClick={onClose} />
            )}
        </div>
    );
}

export default BottomDrawerHeader;
